import { IconProps } from "types/v2/common/IconProps";

const RefreshIcon:React.FC<IconProps> = ({onClick}) => {
  return (
    <svg
      onClick={onClick}
      width="24"
      height="30"
      viewBox="0 0 24 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.334 1.66602L10.6673 4.32662L10.7463 4.40567M10.7463 4.40567L13.334 6.99935M10.7463 4.40567C11.1576 4.35747 11.5763 4.33268 12.0007 4.33268C17.8917 4.33268 22.6673 9.10831 22.6673 14.9993C22.6673 18.3679 21.1058 21.3717 18.6673 23.3265M10.6673 22.9995L13.334 25.5471L13.2944 25.5883M13.2944 25.5883C12.8704 25.6396 12.4385 25.666 12.0007 25.666C6.10961 25.666 1.33398 20.8904 1.33398 14.9993C1.33398 11.6308 2.89541 8.62701 5.33398 6.67219M13.2944 25.5883L10.6673 28.3328"
        stroke="#9CD3D3"
        strokeWidth="2.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default RefreshIcon;
